export default __webpack_public_path__ + "static/media/Lizard.0b2f80b1.png";